import React, { Component, useState, useEffect } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import { Icon } from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import EQ5DForm from './EQ5DForm.js'

//Ruler img
import ruler_grey from '../../Images/Healthform/ruler_grey.png';
import ruler_green from '../../Images/Healthform/ruler_green.png';
import ruler_orange from '../../Images/Healthform/ruler_orange.png';
import ruler_red from '../../Images/Healthform/ruler_red.png';

class EQ5DHealthscaleDisplay extends Component {

    //Function to display form healthscale alert logo with the good color
    getFormHealthscaleImg(){
        if(this.props.healthscaleDisplay.color === "#21BA45"){
            //return green
            return (<img src={ruler_green} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="ruler_logo"/>)
        }
        else if(this.props.healthscaleDisplay.color === "#F2711C"){
            //return orange
            return (<img src={ruler_orange} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="ruler_logo"/>)
        }
        else if(this.props.healthscaleDisplay.color === "#DB2828"){
            //return orange
            return (<img src={ruler_red} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="ruler_logo"/>)
        }
        else{
            //return grey
            return (<img src={ruler_grey} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="ruler_logo"/>)
        }
    }

    display_value(){

        let unit = ""
        if (this.props.healthscaleDisplay.healthscale !== "-"){
            unit = "/100"
        }

        return(
            <Row style={{ flex:1, flexDirection:'row', alignItems:'left', justifyContent:'left', paddingTop:"5%", paddingBottom:"5%"}}>
                {
                    this.getFormHealthscaleImg()
                }
                <Row>                    
                    <div style={{color: this.props.healthscaleDisplay.color}}>
                        <span id="row-measure-style">{this.props.healthscaleDisplay.healthscale}</span>
                        <span id="row-unit-style">{unit}</span>                        
                    </div>                    
                </Row>
            </Row>
        )
    }

    //Display render
    render(){
        return (
            <div>
                {(this.props.alert) ?
                    <Col style={{backgroundColor: "yellow"}}>
                        {this.display_value()}
                    </Col>
                    :
                    <Col>
                        {this.display_value()}
                    </Col>
                }
            </div>
        );
    }
}
export default (EQ5DHealthscaleDisplay);